module.exports = __webpack_public_path__ + "static/media/travel15.c50e17dc.jpg";